import { Injectable } from '@angular/core';
import { Globals } from '../globals';

@Injectable({
    providedIn: 'root'
})
export class RegTokenServiceService {

    constructor(private global: Globals) { }

    private deviceId = "";
    private processId = "";
    private checksum = "";
    private adjustedFlagTime = "";
    private encounterNo = "";
    private flagTime = "";
    private inventoryAdjustedFlagTime = "";
    private inventoryEncounterNo = "";
    private successMessageTitle = "";
    private messageType = "";
    private successMessageBody = "";
    private user = {};
    private mails = [];
    private picturePasswordUrl = "";
    private authorized = false;
    private deviceIdList: any;
    private amount: any;
    private currentUserId: any;
    private transactionNo: any;
    public transactionId: any;
    private timestamp: any;

    public getCurrentUserId = function (this: RegTokenServiceService) {
        return this.currentUserId;
    }

    public setCurrentUserId = function (this: RegTokenServiceService, currentUserId: any) {
        this.currentUserId = currentUserId;
    }


    public getDeviceIdKey = function (this: RegTokenServiceService) {
        return this.global.DEVICE_ID;
    }

    public getOldTokenKey = function (this: RegTokenServiceService) {
        return this.global.OLD_TOKENS;
    }

    public getNewTokenKey = function (this: RegTokenServiceService) {
        return this.global.NEW_TOKENS;
    }

    public setDeviceIdList =  (deviceIdList: any) => {
        this.deviceIdList = deviceIdList;
    }

    public getDeviceIdList = function (this: RegTokenServiceService) {
        return this.deviceIdList;
    }

    public setAmount =  (amount: any) => {
        this.amount = amount;
    }

    public getAmount = function (this: RegTokenServiceService) {
        return this.amount;
    }

    public setAuthorized =  (authorize: any) => {
        this.authorized = authorize;
    }

    public isAuthorized = function (this: RegTokenServiceService) {
        return this.authorized;
    }

    public getTimeStamp = function (this: RegTokenServiceService) {
        return this.timestamp;
    }

    public setTimeStamp =  (timestamp: any) => {
        this.timestamp = timestamp;
    }

    public getPicturePasswordUrl = function (this: RegTokenServiceService) {
        return this.picturePasswordUrl;
    }

    public setPicturePasswordUrl =  (picturePasswordUrl: any) => {
        this.picturePasswordUrl = picturePasswordUrl;
    }

    public getSuccessMessageTitle = function (this: RegTokenServiceService) {
        return this.successMessageTitle;
    }

    public getSuccessMessageBody = function (this: RegTokenServiceService) {
        return this.successMessageBody;
    }

    public getMessageType = function (this: RegTokenServiceService) {
        return this.messageType;
    }

    public setMessageType =  (type: any) => {
        this.messageType = type;
    }

    public setSuccessMessageTitle =  (successMessageTitle: any) => {
        this.successMessageTitle = successMessageTitle;
    }

    public setSuccessMessageBody =  (successMessageBody: any) => {
        this.successMessageBody = successMessageBody;
    }

    public isNullOrEmptyOrUndefined = function (value: any) {
        return !value;
    }

    public setChecksum =  (checksum: any) => {
        this.checksum = checksum;
    }

    public setAdjustedFlagTime =  (adjustedFlagTime: any) => {
        this.adjustedFlagTime = adjustedFlagTime;
    }

    public setFlagTime =  (flagTime: any) => {
        this.flagTime = flagTime;
    }

    public setEncounterNumber =  (encounterNo: any) => {
        this.encounterNo = encounterNo;
    }

    public setProcessId =  (processId: any) => {
        this.processId = processId;
    }

    public setDeviceId =  (deviceId: any) => {
        this.deviceId = deviceId;
    }

    public getDeviceId = function (this: RegTokenServiceService) {
        return this.deviceId;
    }

    public setInventoryAdjFlagTime =  (inventoryAdjustedFlagTime: any) => {
        this.inventoryAdjustedFlagTime = inventoryAdjustedFlagTime;
    }

    public getInventoryAdjFlagTime = function (this: RegTokenServiceService) {
        return this.inventoryAdjustedFlagTime;
    }

    public setInventoryEncounterNo =  (inventoryEncounterNo: any) => {
        this.inventoryEncounterNo = inventoryEncounterNo;
    }

    public getInventoryEncounterNo = function (this: RegTokenServiceService) {
        return this.inventoryEncounterNo;
    }

    public getProcessId = function (this: RegTokenServiceService) {
        return this.processId;
    }

    public getChecksum = function (this: RegTokenServiceService) {
        return this.checksum;
    }

    public getAdjustedFlagTime = function (this: RegTokenServiceService) {
        return this.adjustedFlagTime;
    }

    public getFlagTime = function (this: RegTokenServiceService) {
        return this.flagTime;
    }

    public getEncounterNo = function (this: RegTokenServiceService) {
        return this.encounterNo;
    }

    public setEncounterNo =  (no: any) => {
        this.encounterNo = no;
    }

    public setUser =  (user: any) => {
        this.user = user;
    }
    public getUser = function (this: RegTokenServiceService) {
        return this.user;
    }

    public setHMail =  (mails: any) => {
        this.mails = mails;
    }
    public getHMails = function (this: RegTokenServiceService) {
        return this.mails;
    }

    public getTransactionNo = function (this: RegTokenServiceService) {
        return this.transactionNo;
    }

    public setTransactionNo =  (no: any) => {
        this.transactionNo = no;
    }

    public getTransactionId = function (this: RegTokenServiceService) {
        return this.transactionId;
    }

    public setTransactionId =  (id: any) => {
        this.transactionId = id;
    }

    public getDefaultToken = function () {
        return {
            "deviceId": "",
            "processId": "",
            "label": "",
            "token": "",
            "timeOffset": "",
            "timeCalc": "",
            "checksum": "",
            "stepUsed": "",
            "flagTime": "",
            "adjFlagTime": "",
            "matchTime": "",
            "valid": ""
        };
    }

    public getDefaultMessage = function () {
        return {
            "deviceId": "",
            "processId": "",
            "senderId": "",
            "label": "",
            "encounterNo": "",
            "serial1": "",
            "serial2": "",
            "timestamp": "",
            "checksum": "",
            "token": "",
            "timeOffset": "",
            "timeCalc": "",
            "tokenChecksum": "",
            "flagTime": "",
            "adjustedFlagTime": "",
            "matchTime": 0,
            "answer1": "",
            "answer2": "",
            "answer3": "",
            "answer4": "",
            "answer5": "",
            "oldDeviceTokens": [],
            "newDeviceTokens": [],
            "picturePasswordUrl": "",
            "otp": "",
            "hubId": "",
            "publicKey1": "",
            "publicKey2": "",
            "selectedManufacturer": "",
            "email": {
                "recipients": "",
                "subject": "",
                "body": ""
            },
            "globalDevice": [],
            "rdfLabel": ""
        };
    }
}
